export default __webpack_public_path__ + "magix-sequoia.028ee570.png";